import { ChatLayoutContextWrapper } from 'Components/Chat/contexts/ChatLayoutContextWrapper';
import GroupInfo from 'Components/GroupInfo';

import { ContextPanel } from 'Containers/ContextPanel';
import ConversationsPanel from 'Containers/ConversationsPanel';
import React from 'react';

export const ChatPage: React.FC = () => {
  return (
    <ChatLayoutContextWrapper>
      <ConversationsPanel />
      <ContextPanel />
      <GroupInfo />
    </ChatLayoutContextWrapper>
  );
};
